import { StytchUIClient } from '@stytch/vanilla-js'

// Initialize Stytch client
export const stytch = new StytchUIClient(
  import.meta.env.VITE_STYTCH_PUBLIC_TOKEN
)
